module.exports = __webpack_public_path__ + "img/hero-icon-paw-1.815fcb9a.svg";